import fp from "lodash/fp";

export default function mapProcessorForm(form) {
	if (fp.isEmpty(form)) return;
	const getStartedModel = {
		...form.mccCodeSection,
		processorId: form?.processorSponsorSection?.processor?.id,
		sponsorId: form?.processorSponsorSection?.sponsor?.id,
		primaryAgentId: form?.primaryAgentId,
		headquarterAccountId: form?.headquarters?.id,
		scheduleAId: form?.residualsSection?.scheduleA?.id,
		splitProfileId: form?.residualsSection?.splitProfile?.id,
		achProcessor: form?.processorSponsorSection?.achProcessor,
	};

	return getStartedModel;
}
